module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0037.png.b69763d0.jpg";